export default "__VITE_ASSET__CVD9xQnV__"